export enum DocumentControlType {
    YES = 'YES',
    HARD_COPY = 'HARD_COPY',
    ECOPY = 'ECOPY',
    NO = 'NO',
    NA = 'NA',
}
